module.exports = __webpack_public_path__ + "img/logo.037cdd26.png";